import { type PublicPlayerDealResponsePagedData } from '@on3/api';
import { Pagination } from '@on3/ui-lib/components/Pagination/Pagination';
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb';
import { CompactPlayer } from 'components/Db/Profile/Header/CompactHeaderV2/CompactPlayerV2';
import useAthlete from 'contexts/AthleteProvider';

import { PlayerNilDeals } from './PlayerNilDeals';
import styles from './PlayerNilDealsPage.module.scss';

interface IPlayerNilDealsPageProps {
  playerDeals?: PublicPlayerDealResponsePagedData;
}

export const PlayerNilDealsPage = ({
  playerDeals,
}: IPlayerNilDealsPageProps) => {
  const { pagination } = playerDeals || {};
  const { athlete } = useAthlete();

  return (
    <div className={styles.block}>
      {/* TODO: Coming back to make inner db layout a thing */}
      <CompactPlayer className={styles.compactPlayer} />
      <BreadCrumb
        className={styles.breadcrumbs}
        crumbs={[
          { title: 'On3 DB', href: '/db/' },
          {
            title: athlete.name ?? 'Player Profile',
            href: `/db/${athlete.slug}/`,
          },
        ]}
        title="NIL Deals"
      />
      <section className={styles.deals}>
        <h1>NIL Deals for {athlete.name}</h1>
        <Pagination data={pagination} type="simple" />
        <PlayerNilDeals playerDeals={playerDeals} showAll />
        <Pagination data={pagination} type="simple" />
      </section>
    </div>
  );
};
